<div class="row">
    <div class="col-12">
        <mat-card appearance="outlined">
            <sm-title-bar pageSubTitle="All unblock requests" [showBackButton]="true"></sm-title-bar>
            <div class="rounded-3 bg-light">
              <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="requestList"
                [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate" [showPagination]="true" [itemsPerPage]="5">

                <ng-template #customMessage let-rowValue="row" let-colValue="col">
                  <mat-chip-listbox aria-label="Message">
                    <mat-chip color="accent" selected>{{rowValue[colValue.columnProperty]}}</mat-chip>
                  </mat-chip-listbox>
                </ng-template>
                
              </sm-data-table>
            </div>
          </mat-card>
    </div>
</div>

<ng-template #menuTemplate let-value>
    <button mat-menu-item>
      <mat-icon class="material-icons-outlined">mail</mat-icon>
      <span>Message</span>
    </button>
    <button mat-menu-item>
      <mat-icon class="material-icons-outlined">verified_user</mat-icon>
      <span>Unblock</span>
    </button>
  </ng-template>